import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { forgot_password } from "../../redux/actions/adminActions";
import Loader from "../../components/Loader/Loader";
import { Link } from "react-router-dom";
import "./forgot.scss";

const Forgot = () => {
  const [email, setEmail] = useState("");
  const [forgotError, setForgotError] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const forgotPassword = useSelector((state) => state.forgotPassword);
  const { loading, password, error } = forgotPassword;
  const dispatch = useDispatch();

  const isValidateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidateEmail) {
      return setIsEmpty(true);
    }
    dispatch(forgot_password(email, clear));
  };
  const clear = () => {
    setEmail("");
  };
  useEffect(() => {
    if (error) {
      setForgotError(true);
    }
  }, [error]);

  return (
    <div className="container">
      <Loader isLoading={loading} />
      <form onSubmit={handleSubmit} className="form_container">
        <h2 data-testid="forgot-1" className="wel">
          Forgot Password
        </h2>
        <lable className="emaillabel">Enter Email</lable>
        <div className="passwordlable">
          <input
            type="email"
            placeholder="Enter your email"
            name="email"
            className="input"
            onChange={(e) => {
              setEmail(e.target.value);
              setForgotError(false);
              setIsEmpty(false);
            }}
          />
        </div>
        {forgotError && (
          <p className="error-msg">
            Email address not found or you are not yet registered
          </p>
        )}
        {isEmpty && <p className="error-msg">Invalid email id</p>}
        <button data-testid="button" type="submit" className="green_btn">
          Submit
        </button>
      </form>
    </div>
  );
};

export default Forgot;
